import React, { ReactNode } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: ReactNode;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, currentPage = 'planner', onNavigate }) => {
  // Check if sidebar should be used (stored preference)
  const useSidebar = localStorage.getItem('useSidebarNav') !== 'false';

  if (useSidebar) {
    return (
      <div className="min-h-screen bg-gray-50" style={{ display: 'flex' }}>
        <Sidebar currentPage={currentPage} onNavigate={onNavigate || (() => {})} />
        <div style={{ 
          flex: 1, 
          marginLeft: '200px', // Sidebar width
          transition: 'margin-left 0.2s ease'
        }}>
          <Header currentPage={currentPage} onNavigate={onNavigate} hideTabs={true} />
          <main>
            {children}
          </main>
        </div>
      </div>
    );
  }

  // Fallback to horizontal tabs (original behavior)
  return (
    <div className="min-h-screen bg-gray-50">
      <Header currentPage={currentPage} onNavigate={onNavigate} />
      <main>
        {children}
      </main>
    </div>
  );
};

export default Layout;
